"use strict";
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
var styles = {
    flexContainer: 'flexContainer_249905c8',
    root: 'root_249905c8',
    screenReaderOnly: 'screenReaderOnly_249905c8',
};
load_themed_styles_1.loadStyles([{ "rawString": ".flexContainer_249905c8{display:-webkit-box;display:-ms-flexbox;display:flex;height:100%;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.root_249905c8{outline:transparent}.screenReaderOnly_249905c8{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}" }]);
module.exports = styles;
/* tslint:enable */ 

//# sourceMappingURL=BaseButton.scss.js.map



//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/Button/BaseButton.scss.js
// module id = 223
// module chunks = 0